import type { AppFocusContext } from './appFocus.types'

/** Tablet/mobile renders the active window fullscreen even when `isMinimized`. */
export const isActiveWindowForcedFullscreenAtLowWidth = ({
  isTablet,
  isMobile,
  isActiveWindow
}: {
  isTablet: boolean
  isMobile: boolean
  isActiveWindow: boolean
}): boolean => (isTablet || isMobile) && isActiveWindow

export const shouldSkipAppFocusTracking = (context: AppFocusContext): boolean =>
  context.isNestedContainer && context.isDetachedRoute

export const isAppFocusStateReady = (context: AppFocusContext): boolean => {
  if (shouldSkipAppFocusTracking(context)) return false

  if (context.isDetachedRoute) {
    return !context.isAppsLoading
  }

  if (!context.isWindowStoreHydrated) return false
  if (context.activeWindowId && context.isAppsLoading) return false

  return true
}

export const resolveInTabActualFocusedApp = (
  context: AppFocusContext
): string | null | undefined => {
  if (shouldSkipAppFocusTracking(context)) return undefined

  const typeMatches = context.isDetachedRoute
    ? context.activeAppType === 'detached'
    : context.activeAppType === 'window'

  if (context.activeAppId && !typeMatches) return undefined

  return context.activeAppId && typeMatches && !context.effectiveMinimized
    ? context.activeAppId
    : null
}
